import { ResetPasswordSendOtpApiNamespace } from '@core/models/api';

export namespace ResetPasswordSendOtpNamespace {
  export interface IN {
    login: string;
    password: string;
    passwordConfirm: string;
    recaptchaToken: string;
  }

  export class OUT {
    requestKey: string = '';

    init(input: ResetPasswordSendOtpApiNamespace.OUT) {
      this.requestKey = input.recoverPasswordKey;

      return this;
    }
  }
}
